/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-chevron-left': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M6.25 10l6.25-6.25.875.875L8 10l5.375 5.375-.875.875z"/>'
  }
})
